import React from 'react';

import { View } from 'react-native';

import gStyles from 'config/styles';

import { EmbeddedPlayerHostPortalProps } from './types';

function EmbeddedPlayerHostPortal({
    id,
    children,
}: EmbeddedPlayerHostPortalProps) {
    return (
        <View id={id} style={gStyles.flex}>
            {children}
        </View>
    );
}

export default EmbeddedPlayerHostPortal;
